import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class ScriptVersionService {
  private readonly http = inject(HttpClient);
  private readonly router = inject(Router);

  private currentScriptFileName = '';
  public updateRequired: boolean = false;

  public constructor() {
    const configService = inject(ConfigService);

    // Doesn't work properly when running locally due to how the dev server handles files
    if (!configService.isLocal) {
      this.getCurrentScriptFileName();
      this.monitorNavigation();
    }
  }

  private getCurrentScriptFileName(): void {
    const script = document.querySelector('script[src*="main"]') as HTMLScriptElement;
    this.currentScriptFileName = script ? script.getAttribute('src') || '' : '';
  }

  private monitorNavigation(): void {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.checkForScriptUpdate();
    });
  }

  private checkForScriptUpdate(): void {
    if (!this.currentScriptFileName) {
      return;
    }

    const headers = new HttpHeaders({
      'Cache-Control': 'no-cache',
    });
    this.http.get(this.currentScriptFileName, { headers, observe: 'response', responseType: 'text' }).subscribe({
      next: response => {
        const contentTypeHeader = response.headers.get('content-type');
        this.updateRequired = !contentTypeHeader?.includes('application/javascript');
      },
      error: () => {
        this.updateRequired = true;
      },
    });
  }
}
